const calculateAge = (date) => {
    if (!date) return null;

    const birth = new Date(date);
    const today = new Date();

    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    const dayDiff = today.getDate() - birth.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
    }

    return age;
};

// פונקציה לבדיקה אם יש ילדים מתחת לגיל 21
export const countChildrenUnder21 = (familyArray) => {
    console.log(!Array.isArray(familyArray), "!Array.isArray(familyArray)");

    if (!Array.isArray(familyArray)) return 0;

    return familyArray.filter(
        (member) => member.Closeness === "ילד" && calculateAge(member.DateOfBirth) < 21
    ).length;
};

export const getFamilyPackageInfo = (numLittleChildren) => {
    const isFamily = numLittleChildren >= 2;
    const btnText = isFamily ? "משפחתית" : "רגילה";
    return btnText;
};